import { render } from "./TechSupport.vue?vue&type=template&id=62a223d9"
import script from "./TechSupport.vue?vue&type=script&lang=js"
export * from "./TechSupport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__